const MOVE_SPEED = {
  STOPPED: { PIXELS: 0, FACTOR: 0.0 },
  SLOW: { PIXELS: 0.5, FACTOR: 0.005 },
  SLOWMEDIUM: { PIXELS: 1, FACTOR: 0.01 },
  MEDIUM: { PIXELS: 2, FACTOR: 0.035 },
  MEDIUMFAST: { PIXELS: 3, FACTOR: 0.05 },
  FAST: { PIXELS: 4, FACTOR: 0.09 },
};

class FlightMode {
  FlyCursor = null;
  mapView = null;
  isEnabled = false;
  flyJobPointer = null;

  constructor(mapView) {
    import("style/icons/3DFlyTool32.cur").then((image) => {
      this.FlyCursor = image.default;
    });

    this.mapView = mapView;
  }

  flyAction = function(evt) {
    if (this.isEnabled) {
      if (!evt) return;
      if (this.mapView.container) {
        this.mapView.container.style.cursor =
          `url('${this.FlyCursor}'),auto` || "default";
      }
      // MAP CENTER //
      this._mapCenterPoint = {
        x: this.mapView.position[0] + this.mapView.width * 0.5,
        y: this.mapView.position[1] + this.mapView.height * 0.5,
      };

      // MOUSE MOVE //
      this._mouseMovePoint = {
        x: evt.clientX,
        y: evt.clientY,
      };

      this._mouseMovePoint.y -= 1; // FORCE UPDATES TO START RIGHT AWAY //

      this._fly();
      if (!this.flyJobPointer) {
        this.flyJobPointer = setInterval(
          function() {
            this._fly();
          }.bind(this),
          50
        );
      }
    } else {
      clearInterval(this.flyJobPointer);
      this.flyJobPointer = null;
      if (this.mapView.container) {
        this.mapView.container.style.cursor = "default";
      }
    }
  }.bind(this);

  _fly() {
    if (this._mapCenterPoint) {
      this._moveSpeed = MOVE_SPEED.SLOW;
      // CALC MOVE DELTAS //
      var viewWidthHeight = (this.mapView.width + this.mapView.height) * 0.5;
      var speedFactorX = Math.abs(
        (this._mapCenterPoint.x - this._mouseMovePoint.x) / viewWidthHeight
      );
      var speedFactorY = Math.abs(
        (this._mapCenterPoint.y - this._mouseMovePoint.y) / viewWidthHeight
      );
      var deltaX =
        (this._mapCenterPoint.x > this._mouseMovePoint.x
          ? this._moveSpeed.PIXELS
          : -this._moveSpeed.PIXELS) * speedFactorX;
      var deltaY =
        (this._mapCenterPoint.y > this._mouseMovePoint.y
          ? this._moveSpeed.PIXELS
          : -this._moveSpeed.PIXELS) * speedFactorY;

      // VIEW CAMERA //
      var camera = this.mapView.camera.clone();
      camera.tilt += deltaY;
      if (camera.tilt > 110) camera.tilt = 110;
      if (camera.tilt < 0) camera.tilt = 0;
      camera.heading -= deltaX;

      var distanceOffset = camera.position.z * this._moveSpeed.FACTOR;

      // XY OFFSETS //
      var offsetX =
        Math.sin((camera.heading * Math.PI) / 180.0) * distanceOffset;
      var offsetY =
        Math.cos((camera.heading * Math.PI) / 180.0) * distanceOffset;

      // ALTITUDE OFFSET //
      var offsetZ = 0.0;
      if (!this._holdElevation) {
        var tiltHorizon = 90.0;
        var horizonOffset =
          camera.tilt < tiltHorizon
            ? -(tiltHorizon - camera.tilt)
            : camera.tilt - tiltHorizon;
        offsetZ = (horizonOffset / tiltHorizon) * distanceOffset;
      }

      var tiltOn = true;
      var keepHorz = false;
      var newPosition = camera.position.offset(
        offsetX,
        offsetY,
        tiltOn ? offsetZ : keepHorz ? 0 : this.offsetZ ? this.offsetZ : 0
      );

      if (!keepHorz) {
        this.offsetZ = offsetZ;
      }

      camera.position = newPosition;

      // UPDATE CAMERA //
      try {
        // let tmpView = this.mapView.clone();
        // tmpView.camera = camera;
        // this.setState({view:tmpView})
        this.mapView.camera = camera;
      } catch (e) {
        console.log(e);
      }
    }
  }

  toggleFlyMode(forceValue) {
    this.isEnabled = typeof forceValue !== "undefined" ? forceValue : !this.isEnabled;
    if (this.isEnabled) document.addEventListener("mousemove", this.flyAction);
    else document.removeEventListener("mousemove", this.flyAction);
    this.flyAction();
  }
}
export default FlightMode;
